export { default } from './DocumentsUploader';
export type { TDocumentsUploaderProps } from './types';
